// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-container {
  max-width: 600px;
  margin: 0 auto;
}

.game-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.game-progress {
  background: var(--primary);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 700;
}

.game-score {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 24px;
}

.quiz-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: var(--shadow);
  margin-bottom: 24px;
  position: relative;
}

.quiz-word {
  font-size: 40px;
  font-weight: 800;
  color: var(--primary);
}

.speak-btn-game {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 48px;
  height: 48px;
  border: none;
  background: var(--accent);
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
}

.quiz-instruction {
  text-align: center;
  color: var(--text-light);
  margin-bottom: 16px;
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.option-btn {
  background: white;
  border: 3px solid var(--border);
  border-radius: 16px;
  padding: 20px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

@media (hover: hover) and (pointer: fine) {
  .option-btn:hover:not(:disabled) {
    border-color: var(--primary);
    transform: scale(1.02);
  }
}

.option-btn:focus {
  outline: none;
  border-color: var(--border);
}

.option-btn.correct {
  background: var(--success);
  border-color: var(--success);
  color: white;
}

.option-btn.wrong {
  background: var(--danger);
  border-color: var(--danger);
  color: white;
}

/* Listening game */
.listening-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: var(--shadow);
  margin-bottom: 24px;
}

.big-speak-btn {
  width: 100px;
  height: 100px;
  border: none;
  background: linear-gradient(135deg, var(--accent), #1976D2);
  border-radius: 50%;
  font-size: 48px;
  cursor: pointer;
  margin-bottom: 12px;
  transition: transform 0.2s;
}

.big-speak-btn:hover {
  transform: scale(1.1);
}

/* Matching game */
.matching-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.matching-card {
  background: white;
  border: 3px solid var(--border);
  border-radius: 12px;
  padding: 16px 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 60px;
}

.matching-card.english {
  border-color: var(--accent);
  color: var(--accent);
}

.matching-card.polish {
  border-color: var(--secondary);
  color: var(--secondary);
}

.matching-card.selected {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.matching-card.matched {
  background: var(--success);
  border-color: var(--success);
  color: white;
  opacity: 0.7;
}

/* Complete & Error screens */
.game-complete, .game-error {
  text-align: center;
  padding: 60px 20px;
}

.game-complete .complete-icon, .game-error h2 {
  font-size: 80px;
  margin-bottom: 16px;
}

.bonus-badge {
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #333;
  padding: 12px 24px;
  border-radius: 20px;
  font-size: 24px;
  font-weight: 800;
  display: inline-block;
  margin: 16px 0 24px;
}

/* Spelling game */
.spelling-card {
  background: white;
  border-radius: 24px;
  padding: 32px;
  text-align: center;
  box-shadow: var(--shadow);
  margin-bottom: 24px;
}

.polish-word {
  font-size: 42px;
  font-weight: 800;
  color: var(--secondary);
  margin-bottom: 16px;
}

.spelling-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.spelling-input {
  width: 100%;
  max-width: 300px;
  padding: 16px 20px;
  font-size: 24px;
  border: 3px solid #ddd;
  border-radius: 16px;
  text-align: center;
  outline: none;
  transition: border-color 0.2s;
}

.spelling-input:focus {
  border-color: var(--accent);
}

.spelling-input.correct {
  border-color: var(--success);
  background: #e8f5e9;
}

.spelling-input.wrong {
  border-color: var(--danger);
  background: #ffebee;
}

.correct-answer {
  margin-top: 16px;
  padding: 12px 20px;
  background: #fff3e0;
  border-radius: 12px;
  font-size: 18px;
  color: #e65100;
}

.correct-answer strong {
  color: var(--success);
}

.speak-btn-inline {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  margin-left: 8px;
  vertical-align: middle;
}

.btn-next {
  margin-top: 24px;
  font-size: 20px;
  padding: 14px 32px;
}

/* Sentence game */
.sentence-card {
  background: white;
  border-radius: 24px;
  padding: 32px;
  text-align: center;
  box-shadow: var(--shadow);
}

.sentence-answer-area {
  min-height: 60px;
  padding: 16px;
  margin: 16px 0;
  background: #f5f5f5;
  border-radius: 16px;
  border: 3px dashed #ddd;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}

.sentence-answer-area.correct {
  border-color: var(--success);
  background: #e8f5e9;
}

.sentence-answer-area.wrong {
  border-color: var(--danger);
  background: #ffebee;
}

.placeholder-text {
  color: #999;
  font-style: italic;
}

.word-bank {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin: 20px 0;
  min-height: 50px;
}

.word-chip {
  padding: 12px 20px;
  font-size: 18px;
  font-weight: 600;
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.word-chip:hover:not(:disabled) {
  transform: scale(1.05);
  background: var(--primary);
}

.word-chip.selected {
  background: var(--secondary);
}

.word-chip:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Anagram Game */
.anagram-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: var(--shadow);
}

.anagram-answer-area {
  min-height: 60px;
  padding: 16px;
  margin: 20px 0;
  background: #f5f5f5;
  border-radius: 16px;
  border: 3px dashed #ddd;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.anagram-answer-area.correct {
  border-color: var(--success);
  background: #e8f5e9;
}

.anagram-answer-area.wrong {
  border-color: var(--error);
  background: #ffebee;
}

.letter-bank {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin: 20px 0;
  min-height: 50px;
}

.letter-chip {
  width: 48px;
  height: 48px;
  font-size: 22px;
  font-weight: 700;
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.letter-chip:hover:not(:disabled) {
  transform: scale(1.1);
  background: var(--primary);
}

.letter-chip.selected {
  background: var(--secondary);
}

.letter-chip:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Fill Gap Game */
.fillgap-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: var(--shadow);
}

.gap-sentence {
  font-size: 24px;
  font-weight: 600;
  color: var(--text);
  padding: 24px;
  margin: 20px 0;
  background: #f5f5f5;
  border-radius: 16px;
  line-height: 1.6;
}

.gap-sentence.correct {
  background: #e8f5e9;
  color: var(--success);
}

.gap-sentence.wrong {
  background: #ffebee;
  color: var(--error);
}

.fillgap-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin: 20px 0;
}

.fillgap-options .option-btn {
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 600;
  background: white;
  border: 3px solid var(--primary);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.fillgap-options .option-btn:hover:not(:disabled) {
  background: var(--primary);
  color: white;
}

.fillgap-options .option-btn.correct {
  background: var(--success);
  border-color: var(--success);
  color: white;
}

.fillgap-options .option-btn.wrong {
  background: var(--error);
  border-color: var(--error);
  color: white;
}

.fillgap-options .option-btn:disabled {
  cursor: not-allowed;
}

/* Dictation Game */
.dictation-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: var(--shadow);
}

.dictation-controls {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin: 24px 0;
}

.btn-listen {
  padding: 20px 32px;
  font-size: 20px;
  font-weight: 700;
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-listen:hover:not(:disabled) {
  transform: scale(1.05);
  background: var(--primary);
}

.btn-listen-slow {
  padding: 20px 24px;
  font-size: 18px;
  font-weight: 600;
  background: #f5f5f5;
  color: var(--text);
  border: 2px solid #ddd;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-listen-slow:hover:not(:disabled) {
  background: #e0e0e0;
}

.hint-text {
  font-size: 16px;
  color: var(--text-light);
  margin: 16px 0;
  font-style: italic;
}

.dictation-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
}

.dictation-form .spelling-input {
  max-width: 100%;
}

.correct-feedback {
  margin-top: 16px;
  padding: 16px;
  background: #e8f5e9;
  border-radius: 12px;
  color: var(--success);
  font-size: 18px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/games/Games.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,2DAA2D;EAC3D,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;EACZ,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".game-container {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.game-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.game-progress {\n  background: var(--primary);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: 700;\n}\n\n.game-score {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 24px;\n}\n\n.quiz-card {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  text-align: center;\n  box-shadow: var(--shadow);\n  margin-bottom: 24px;\n  position: relative;\n}\n\n.quiz-word {\n  font-size: 40px;\n  font-weight: 800;\n  color: var(--primary);\n}\n\n.speak-btn-game {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 48px;\n  height: 48px;\n  border: none;\n  background: var(--accent);\n  border-radius: 50%;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.quiz-instruction {\n  text-align: center;\n  color: var(--text-light);\n  margin-bottom: 16px;\n}\n\n.options-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.option-btn {\n  background: white;\n  border: 3px solid var(--border);\n  border-radius: 16px;\n  padding: 20px;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .option-btn:hover:not(:disabled) {\n    border-color: var(--primary);\n    transform: scale(1.02);\n  }\n}\n\n.option-btn:focus {\n  outline: none;\n  border-color: var(--border);\n}\n\n.option-btn.correct {\n  background: var(--success);\n  border-color: var(--success);\n  color: white;\n}\n\n.option-btn.wrong {\n  background: var(--danger);\n  border-color: var(--danger);\n  color: white;\n}\n\n/* Listening game */\n.listening-card {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  text-align: center;\n  box-shadow: var(--shadow);\n  margin-bottom: 24px;\n}\n\n.big-speak-btn {\n  width: 100px;\n  height: 100px;\n  border: none;\n  background: linear-gradient(135deg, var(--accent), #1976D2);\n  border-radius: 50%;\n  font-size: 48px;\n  cursor: pointer;\n  margin-bottom: 12px;\n  transition: transform 0.2s;\n}\n\n.big-speak-btn:hover {\n  transform: scale(1.1);\n}\n\n/* Matching game */\n.matching-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.matching-card {\n  background: white;\n  border: 3px solid var(--border);\n  border-radius: 12px;\n  padding: 16px 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-height: 60px;\n}\n\n.matching-card.english {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.matching-card.polish {\n  border-color: var(--secondary);\n  color: var(--secondary);\n}\n\n.matching-card.selected {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n}\n\n.matching-card.matched {\n  background: var(--success);\n  border-color: var(--success);\n  color: white;\n  opacity: 0.7;\n}\n\n/* Complete & Error screens */\n.game-complete, .game-error {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.game-complete .complete-icon, .game-error h2 {\n  font-size: 80px;\n  margin-bottom: 16px;\n}\n\n.bonus-badge {\n  background: linear-gradient(135deg, #FFD700, #FFA500);\n  color: #333;\n  padding: 12px 24px;\n  border-radius: 20px;\n  font-size: 24px;\n  font-weight: 800;\n  display: inline-block;\n  margin: 16px 0 24px;\n}\n\n/* Spelling game */\n.spelling-card {\n  background: white;\n  border-radius: 24px;\n  padding: 32px;\n  text-align: center;\n  box-shadow: var(--shadow);\n  margin-bottom: 24px;\n}\n\n.polish-word {\n  font-size: 42px;\n  font-weight: 800;\n  color: var(--secondary);\n  margin-bottom: 16px;\n}\n\n.spelling-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n}\n\n.spelling-input {\n  width: 100%;\n  max-width: 300px;\n  padding: 16px 20px;\n  font-size: 24px;\n  border: 3px solid #ddd;\n  border-radius: 16px;\n  text-align: center;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.spelling-input:focus {\n  border-color: var(--accent);\n}\n\n.spelling-input.correct {\n  border-color: var(--success);\n  background: #e8f5e9;\n}\n\n.spelling-input.wrong {\n  border-color: var(--danger);\n  background: #ffebee;\n}\n\n.correct-answer {\n  margin-top: 16px;\n  padding: 12px 20px;\n  background: #fff3e0;\n  border-radius: 12px;\n  font-size: 18px;\n  color: #e65100;\n}\n\n.correct-answer strong {\n  color: var(--success);\n}\n\n.speak-btn-inline {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  margin-left: 8px;\n  vertical-align: middle;\n}\n\n.btn-next {\n  margin-top: 24px;\n  font-size: 20px;\n  padding: 14px 32px;\n}\n\n/* Sentence game */\n.sentence-card {\n  background: white;\n  border-radius: 24px;\n  padding: 32px;\n  text-align: center;\n  box-shadow: var(--shadow);\n}\n\n.sentence-answer-area {\n  min-height: 60px;\n  padding: 16px;\n  margin: 16px 0;\n  background: #f5f5f5;\n  border-radius: 16px;\n  border: 3px dashed #ddd;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s;\n}\n\n.sentence-answer-area.correct {\n  border-color: var(--success);\n  background: #e8f5e9;\n}\n\n.sentence-answer-area.wrong {\n  border-color: var(--danger);\n  background: #ffebee;\n}\n\n.placeholder-text {\n  color: #999;\n  font-style: italic;\n}\n\n.word-bank {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n  margin: 20px 0;\n  min-height: 50px;\n}\n\n.word-chip {\n  padding: 12px 20px;\n  font-size: 18px;\n  font-weight: 600;\n  background: var(--accent);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.word-chip:hover:not(:disabled) {\n  transform: scale(1.05);\n  background: var(--primary);\n}\n\n.word-chip.selected {\n  background: var(--secondary);\n}\n\n.word-chip:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Anagram Game */\n.anagram-card {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  text-align: center;\n  box-shadow: var(--shadow);\n}\n\n.anagram-answer-area {\n  min-height: 60px;\n  padding: 16px;\n  margin: 20px 0;\n  background: #f5f5f5;\n  border-radius: 16px;\n  border: 3px dashed #ddd;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n}\n\n.anagram-answer-area.correct {\n  border-color: var(--success);\n  background: #e8f5e9;\n}\n\n.anagram-answer-area.wrong {\n  border-color: var(--error);\n  background: #ffebee;\n}\n\n.letter-bank {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n  margin: 20px 0;\n  min-height: 50px;\n}\n\n.letter-chip {\n  width: 48px;\n  height: 48px;\n  font-size: 22px;\n  font-weight: 700;\n  background: var(--accent);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.letter-chip:hover:not(:disabled) {\n  transform: scale(1.1);\n  background: var(--primary);\n}\n\n.letter-chip.selected {\n  background: var(--secondary);\n}\n\n.letter-chip:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Fill Gap Game */\n.fillgap-card {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  text-align: center;\n  box-shadow: var(--shadow);\n}\n\n.gap-sentence {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--text);\n  padding: 24px;\n  margin: 20px 0;\n  background: #f5f5f5;\n  border-radius: 16px;\n  line-height: 1.6;\n}\n\n.gap-sentence.correct {\n  background: #e8f5e9;\n  color: var(--success);\n}\n\n.gap-sentence.wrong {\n  background: #ffebee;\n  color: var(--error);\n}\n\n.fillgap-options {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin: 20px 0;\n}\n\n.fillgap-options .option-btn {\n  padding: 16px 24px;\n  font-size: 18px;\n  font-weight: 600;\n  background: white;\n  border: 3px solid var(--primary);\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.fillgap-options .option-btn:hover:not(:disabled) {\n  background: var(--primary);\n  color: white;\n}\n\n.fillgap-options .option-btn.correct {\n  background: var(--success);\n  border-color: var(--success);\n  color: white;\n}\n\n.fillgap-options .option-btn.wrong {\n  background: var(--error);\n  border-color: var(--error);\n  color: white;\n}\n\n.fillgap-options .option-btn:disabled {\n  cursor: not-allowed;\n}\n\n/* Dictation Game */\n.dictation-card {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  text-align: center;\n  box-shadow: var(--shadow);\n}\n\n.dictation-controls {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  margin: 24px 0;\n}\n\n.btn-listen {\n  padding: 20px 32px;\n  font-size: 20px;\n  font-weight: 700;\n  background: var(--accent);\n  color: white;\n  border: none;\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-listen:hover:not(:disabled) {\n  transform: scale(1.05);\n  background: var(--primary);\n}\n\n.btn-listen-slow {\n  padding: 20px 24px;\n  font-size: 18px;\n  font-weight: 600;\n  background: #f5f5f5;\n  color: var(--text);\n  border: 2px solid #ddd;\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-listen-slow:hover:not(:disabled) {\n  background: #e0e0e0;\n}\n\n.hint-text {\n  font-size: 16px;\n  color: var(--text-light);\n  margin: 16px 0;\n  font-style: italic;\n}\n\n.dictation-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.dictation-form .spelling-input {\n  max-width: 100%;\n}\n\n.correct-feedback {\n  margin-top: 16px;\n  padding: 16px;\n  background: #e8f5e9;\n  border-radius: 12px;\n  color: var(--success);\n  font-size: 18px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
